<script setup>
defineProps({
  name: {
    type: String,
    default: 'error'
  }
})
</script>

<template>
  <svg
    class="status-icon"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <template v-if="name === 'network'">
      <g class="status-icon__satellite" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round">
        <rect x="12" y="11.4" width="8" height="9.2" rx="2" transform="rotate(-8 16 16)" />
        <path d="m12.15 13.25-3.7-2.15-2.05 3.7 4.4 2.05m9.2-3.15 3.95-1.45 1.55 4.1-4.15 1.7" />
        <path d="m15.15 11.25-.65-3.05 2.5-.55" />
        <circle cx="17.05" cy="7.65" r="1.05" fill="currentColor" stroke="none" />
        <circle cx="16" cy="16" r="1.3" fill="currentColor" stroke="none" />
      </g>
      <g class="status-icon__signal" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
        <path d="M21.7 7.45c1.55.2 2.75 1.35 3.05 2.85" />
        <path d="M22.15 4.25c3.05.35 5.45 2.65 5.9 5.65" />
      </g>
    </template>

    <template v-else-if="name === 'empty'">
      <path d="M6.75 10.8 16 5.7l9.25 5.1v10.4L16 26.3l-9.25-5.1V10.8Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="m7.1 11 8.9 4.9 8.9-4.9M16 15.9v10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="m11.3 8.25 9.25 5.1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>

    <template v-else-if="name === 'locked'">
      <rect x="7.25" y="14.05" width="17.5" height="12.1" rx="3" stroke="currentColor" stroke-width="1.8" />
      <path d="M11.1 14.05V10.7a4.9 4.9 0 0 1 9.8 0v3.35" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="16" cy="19.7" r="1.35" fill="currentColor" />
      <path d="M16 21v1.55" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
    </template>

    <template v-else-if="name === 'pending'">
      <circle cx="16" cy="16" r="10.25" stroke="currentColor" stroke-width="1.8" />
      <path d="M16 9.5v6.9l4.35 2.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </template>

    <template v-else-if="name === 'unsupported'">
      <rect x="6.15" y="7.1" width="19.7" height="15.25" rx="2.8" stroke="currentColor" stroke-width="1.8" />
      <path d="M12.1 26h7.8M16 22.35V26M5.8 5.4l20.4 21.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>

    <template v-else>
      <circle cx="16" cy="16" r="10.25" stroke="currentColor" stroke-width="1.8" />
      <path d="M16 10.4v7.2" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" />
      <circle cx="16" cy="22" r="1.2" fill="currentColor" />
    </template>
  </svg>
</template>
